import { render, staticRenderFns } from "./RichEditor.vue?vue&type=template&id=5e3be11c&scoped=true"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"
import style0 from "./RichEditor.vue?vue&type=style&index=0&id=5e3be11c&prod&scoped=true&lang=css"
import style1 from "./RichEditor.vue?vue&type=style&index=1&id=5e3be11c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3be11c",
  null
  
)

export default component.exports